import React from 'react'
import Markdown from 'markdown-to-jsx'

function CustomerAgreements({ blok }) {
    return (
        <div className=' w-full'>
            <div className='bg-asmPageTopBG' style={{
                backgroundSize: "cover", // Ensure the image covers the entire section
                backgroundRepeat: "repeat", // Prevent repeating the background
                // maxWidth: 1920,
                // margin: 'auto'
            }}>
                <div className="font-aileron py-20 lg:py-32 text-center font-bold lg:-mb-20 lg:flex justify-center">
                    <div className="bg-custom-radial bg-clip-text text-transparent text-[40px] lg:text-[80px]">
                        {blok.title}
                    </div>
                    <img src={blok.image.filename} className='max-w-24 max-h-24 lg:ml-10 lg:mt-3 mx-auto mt-10 -mb-14 lg:mb-0 lg:mx-0' />
                </div>
                <div className="p-6 min-h-screen">
                    <div className="max-w-[1500px] mx-auto bg-white shadow-md rounded-lg p-8 font-lato">
                        {/* <h1 className="text-orange-600 text-4xl font-bold">Securin, Inc.</h1>
                        <h2 className="text-2xl font-bold text-purple-800 mt-2">MASTER SERVICES AGREEMENT</h2>
                        <p className="text-orange-600 font-semibold mt-4">Last Updated: December 31st, 2022</p>
                        <p className="mt-4 text-gray-700">
                            This Master Services Agreement ("Agreement") contains the terms for use of the Securin, Inc. and is between Securin, Inc., a Delaware
                            corporation having a place of business at 2440 Louisiana Blvd NE Suite 560, Albuquerque, NM 87110 ("Securin") and the party agreeing to the
                            terms of this Agreement ("CUSTOMER"). By EXECUTING AN ORDER FORM THAT REFERENCES THIS AGREEMENT, clicking an “Accept” or similar button, or
                            otherwise using the Securin, Inc. Platform and/or Professional Services, CUSTOMER agrees to be bound by the terms of this Agreement.
                        </p>
                        <p className="mt-4 text-gray-700 mb-6">
                            CUSTOMER may not ACCESS OR use the Securin, Inc. Platform and/or Professional Services without agreeing to this Agreement first. If a written
                            agreement regarding CUSTOMER’S use of the Securin, Inc. Platform and/or Professional Services exists between and has been executed by both
                            Securin, Inc. and CUSTOMER, the terms of that written agreement shall take precedence over this Agreement.
                        </p> */}
                        {
                            blok?.CustomerAgreementsBlock.map((item, index) => (<div key={index}>
                                {/* <h1 className="text-purple-700 text-xl font-semibold mb-4">
                                    {item.header}
                                </h1> */}
                                <h1 className={`${index === 0 ? 'text-orange-500 text-[36px] mb-0 leading-0' : 'text-purple-700 text-xl mb-4'} font-semibold `}>
                                    {item.header}
                                </h1>
                                <div className='prose prose-li:marker:text-gray-800 mb-6 prose-red max-w-[100%]'>
                                    <Markdown>{item.content}</Markdown>
                                </div>
                            </div>
                            ))
                        }
                    </div>
                </div>
            </div>
            {/* <Footer blok={blok} /> */}
        </div>
    )
}

export default CustomerAgreements